module.exports = __webpack_public_path__ + "img/img10.879031dc.svg";